export class ErpTask {
  constructor(
    public code?: string,
    public name?: string
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/erp-task.ts